module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_angle_left-69a62c85dd38132769de003ca3301736.svg";